export class StockIn {
    constructor(
        public SIID?,
        public SIDT?,
        public Rmk?,
        public EFN?,
        public UploadFileData?
    ) { }
}